module.exports = __webpack_public_path__ + "img/approval-pending.28e303b9.svg";